import { lazyWithRetry } from "utils/lazyWithRetry";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { ROLE } from "utils/constants";
import { usePermissions } from "context/PermissionContext";
import { ProtectedElement } from "./ProtectedElement";
import LazyLoader from "components/lazyLoader";
import AppLayout from "layouts/AppLayout/AppLayout";
const Dashboard = lazyWithRetry(() => import("pages/SuperAdmin/Dashboard"));
const UserActionHistory = lazyWithRetry(
  () => import("pages/SuperAdmin/UserActionHistory"),
);
const EmailLogHistory = lazyWithRetry(
  () => import("pages/SuperAdmin/EmailLogHistory"),
);
const SchedularLogHistory = lazyWithRetry(
  () => import("pages/SuperAdmin/SchedularLogHistory"),
);
const Profile = lazyWithRetry(() => import("features/UserProfile"));
const Roles = lazyWithRetry(() => import("pages/SuperAdmin/Roles/RolesPage"));
const SchedularDetailsPage = lazyWithRetry(
  () => import("pages/SuperAdmin/SchedularDetails/SchedularDetailsPage"),
);
const AddSubClientPage = lazyWithRetry(
  () => import("pages/SuperAdmin/SubClients/AddSubClientPage"),
);
const SubClientsPage = lazyWithRetry(
  () => import("pages/SuperAdmin/SubClients/SubClientsPage"),
);
const AddClient = lazyWithRetry(
  () => import("pages/SuperAdmin/Clients/ClientSetup/AddClientPage"),
);
const ClientsPage = lazyWithRetry(
  () => import("pages/SuperAdmin/Clients/ClientSetup/ClientsPage"),
);
const AddNewUser = lazyWithRetry(
  () => import("pages/SuperAdmin/Users/AddUserPage"),
);
const Users = lazyWithRetry(() => import("pages/SuperAdmin/Users/UsersPage"));
const AddRole = lazyWithRetry(
  () => import("pages/SuperAdmin/Roles/AddRolePage"),
);

const AdminRoutes = () => {
  const { permissions } = usePermissions();

  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute roles={[ROLE.admin]}>
            {/* <IdleTimeoutProvider> */}
            <AppLayout />
            {/* </IdleTimeoutProvider> */}
          </ProtectedRoute>
        }
      >
        <Route
          path="dashboard"
          element={
            <LazyLoader>
              <Dashboard />
            </LazyLoader>
          }
        />
        <Route
          path="log-history/email"
          element={
            <ProtectedElement
              element={<Outlet />}
              requiredPermissions={["EMAIL_LOG"]}
              assignedPermissions={permissions}
            />
          }
        >
          <Route
            index
            element={
              <LazyLoader>
                <EmailLogHistory />
              </LazyLoader>
            }
          />
        </Route>
        <Route
          path="log-history/user"
          element={
            <ProtectedElement
              element={<Outlet />}
              requiredPermissions={["USER_ACTION_HISTORY"]}
              assignedPermissions={permissions}
            />
          }
        >
          <Route
            index
            element={
              <LazyLoader>
                <UserActionHistory />
              </LazyLoader>
            }
          />
        </Route>
        <Route
          path="log-history/schedularLog"
          element={
            <ProtectedElement
              element={<Outlet />}
              requiredPermissions={["SCHEDULER_LOGS"]}
              assignedPermissions={permissions}
            />
          }
        >
          <Route
            index
            element={
              <LazyLoader>
                <SchedularLogHistory />
              </LazyLoader>
            }
          />
        </Route>
        <Route
          path="profile"
          element={
            <LazyLoader>
              <Profile />
            </LazyLoader>
          }
        />
        <Route path="manage-user">
          <Route
            path="role"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["MANAGE_ROLE"]}
                assignedPermissions={permissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <Roles />
                </LazyLoader>
              }
            />
            <Route
              path="addRole"
              element={
                <LazyLoader>
                  <AddRole />
                </LazyLoader>
              }
            />
          </Route>
          <Route
            path="user"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["MANAGE_USER"]}
                assignedPermissions={permissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <Users />
                </LazyLoader>
              }
            />
            <Route
              path="addUser"
              element={
                <LazyLoader>
                  <AddNewUser />
                </LazyLoader>
              }
            />
          </Route>
        </Route>
        <Route
          path="client-setup"
          element={
            <ProtectedElement
              element={<Outlet />}
              requiredPermissions={["CLIENT_DETAILS"]}
              assignedPermissions={permissions}
            />
          }
        >
          <Route
            path="list"
            element={
              <LazyLoader>
                <ClientsPage />
              </LazyLoader>
            }
          />
          <Route
            path="list/add"
            element={
              <LazyLoader>
                <AddClient />
              </LazyLoader>
            }
          />
        </Route>
        <Route
          path="subclient-setup"
          element={
            <ProtectedElement
              element={<Outlet />}
              requiredPermissions={["SUB_CLIENT_DETAILS"]}
              assignedPermissions={permissions}
            />
          }
        >
          <Route
            path="list"
            element={
              <LazyLoader>
                <SubClientsPage />
              </LazyLoader>
            }
          />
          <Route
            path="list/add"
            element={
              <LazyLoader>
                <AddSubClientPage />
              </LazyLoader>
            }
          />
        </Route>
        <Route
          path="schedular-details"
          element={
            <ProtectedElement
              element={<Outlet />}
              requiredPermissions={["SCHEDULER_DETAILS"]}
              assignedPermissions={permissions}
            />
          }
        >
          <Route
            index
            element={
              <LazyLoader>
                <SchedularDetailsPage />
              </LazyLoader>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="dashboard" />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
